import script from "./PlaceItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaceItem.vue?vue&type=script&setup=true&lang=ts"

import "./PlaceItem.vue?vue&type=style&index=0&id=82a02986&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82a02986"]])

export default __exports__